"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOSE_UNSUPPORTED_DATA = exports.CLOSE_TRY_AGAIN_LATER = exports.CLOSE_TLSHANDSHAKE = exports.CLOSE_SERVICE_RESTART = exports.CLOSE_PROTOCOL_ERROR = exports.CLOSE_POLICY_VIOLATION = exports.CLOSE_NO_STATUS_RECEIVED = exports.CLOSE_NORMAL_CLOSURE = exports.CLOSE_MESSAGE_TOO_BIG = exports.CLOSE_MANDATORY_EXTENSION = exports.CLOSE_INVALID_FRAME_PAYLOAD_DATA = exports.CLOSE_INTERNAL_SERVER_ERR = exports.CLOSE_GOING_AWAY = exports.CLOSE_ABNORMAL_CLOSURE = exports.VALIDATION_FAILED = exports.UNAUTHORIZED = exports.PARTIAL_OK = exports.OK = exports.FORBIDDEN = exports.BAD_REQUEST = exports.ACCESS_DENIED = void 0;
// Response codes
exports.ACCESS_DENIED = 406;
exports.BAD_REQUEST = 400;
exports.FORBIDDEN = 403;
exports.OK = 200;
exports.PARTIAL_OK = 206;
exports.UNAUTHORIZED = 401;
exports.VALIDATION_FAILED = 422;
// Server codes
exports.CLOSE_ABNORMAL_CLOSURE = 1006;
exports.CLOSE_GOING_AWAY = 1001;
exports.CLOSE_INTERNAL_SERVER_ERR = 1011;
exports.CLOSE_INVALID_FRAME_PAYLOAD_DATA = 1007;
exports.CLOSE_MANDATORY_EXTENSION = 1010;
exports.CLOSE_MESSAGE_TOO_BIG = 1009;
exports.CLOSE_NORMAL_CLOSURE = 1000;
exports.CLOSE_NO_STATUS_RECEIVED = 1005;
exports.CLOSE_POLICY_VIOLATION = 1008;
exports.CLOSE_PROTOCOL_ERROR = 1002;
exports.CLOSE_SERVICE_RESTART = 1012;
exports.CLOSE_TLSHANDSHAKE = 1015;
exports.CLOSE_TRY_AGAIN_LATER = 1013;
exports.CLOSE_UNSUPPORTED_DATA = 1003;
exports.default = {
    ACCESS_DENIED: exports.ACCESS_DENIED,
    BAD_REQUEST: exports.BAD_REQUEST,
    FORBIDDEN: exports.FORBIDDEN,
    OK: exports.OK,
    PARTIAL_OK: exports.PARTIAL_OK,
    UNAUTHORIZED: exports.UNAUTHORIZED,
    VALIDATION_FAILED: exports.VALIDATION_FAILED,
    CLOSE_ABNORMAL_CLOSURE: exports.CLOSE_ABNORMAL_CLOSURE,
    CLOSE_GOING_AWAY: exports.CLOSE_GOING_AWAY,
    CLOSE_INTERNAL_SERVER_ERR: exports.CLOSE_INTERNAL_SERVER_ERR,
    CLOSE_INVALID_FRAME_PAYLOAD_DATA: exports.CLOSE_INVALID_FRAME_PAYLOAD_DATA,
    CLOSE_MANDATORY_EXTENSION: exports.CLOSE_MANDATORY_EXTENSION,
    CLOSE_MESSAGE_TOO_BIG: exports.CLOSE_MESSAGE_TOO_BIG,
    CLOSE_NORMAL_CLOSURE: exports.CLOSE_NORMAL_CLOSURE,
    CLOSE_NO_STATUS_RECEIVED: exports.CLOSE_NO_STATUS_RECEIVED,
    CLOSE_POLICY_VIOLATION: exports.CLOSE_POLICY_VIOLATION,
    CLOSE_PROTOCOL_ERROR: exports.CLOSE_PROTOCOL_ERROR,
    CLOSE_SERVICE_RESTART: exports.CLOSE_SERVICE_RESTART,
    CLOSE_TLSHANDSHAKE: exports.CLOSE_TLSHANDSHAKE,
    CLOSE_TRY_AGAIN_LATER: exports.CLOSE_TRY_AGAIN_LATER,
    CLOSE_UNSUPPORTED_DATA: exports.CLOSE_UNSUPPORTED_DATA,
};
//# sourceMappingURL=codes.js.map